import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  className = '',
  children,
  ...props
}: CardProps) {
  return <div className={`rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-shadow duration-300 ${className}`} {...props} data-id="element-151">
      {children}
    </div>;
}